export default "__VITE_ASSET__9b8de358__";